import { render, staticRenderFns } from "./IRChip.vue?vue&type=template&id=451b34df&scoped=true"
import script from "./IRChip.vue?vue&type=script&lang=js"
export * from "./IRChip.vue?vue&type=script&lang=js"
import style0 from "./IRChip.vue?vue&type=style&index=0&id=451b34df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b34df",
  null
  
)

export default component.exports